const MAKE_MODEL_EXCEPTIONS = [
  // Alphabetical order
  'AMG',
  'ASX',
  'BYD',
  'bZ4X',
  'ClubSport',
  'D-MAX',
  'EQB',
  'EQS',
  'ES250',
  'EV',
  'Fe',
  'GLA',
  'i20',
  'i30',
  'i40',
  'iLoad',
  'IONIQ',
  'RAM',
  'RAV4',
];

const MAKE_MODEL_EXCEPTIONS_MAP = new Map<string, string>(
  MAKE_MODEL_EXCEPTIONS.map((exception) => [exception.toUpperCase(), exception]),
);

export const capitaliseMakeModel = (name: string): string => {
  const splitName = name.split(' ');
  // Capitalise each part of the name
  return splitName.map(capitaliseMakeModelWord).join(' ');
};

const capitaliseMakeModelWord = (word: string): string => {
  const upperCaseWord = word.toUpperCase();
  // Check if there's a manual overwrite
  if (MAKE_MODEL_EXCEPTIONS_MAP.has(upperCaseWord)) {
    return MAKE_MODEL_EXCEPTIONS_MAP.get(upperCaseWord) ?? word;
  }

  // Process the word parts if it's not an exception
  const wordParts = word.split('-');

  const capitalisedWordParts = wordParts.map(capitaliseMakeModelWordPart);

  return capitalisedWordParts.join('-');
};

const capitaliseMakeModelWordPart = (wordPart: string): string => {
  // Don't change the word if it only contains consonant, numbers or dashes or if it's less than 2 characters
  if (!/[aeiouy]+/i.test(wordPart) || wordPart.length <= 2) {
    return wordPart.toUpperCase();
  }

  return wordPart.charAt(0).toUpperCase() + wordPart.slice(1).toLowerCase();
};
